module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('demo', {
    staticClass: "icon-demo",
    attrs: {
      "title": "Icon"
    }
  }, [_c('demo-item', {
    attrs: {
      "name": "default",
      "description": "默认",
      "code": _vm.size_code,
      "lang": "html"
    }
  }, [_c('Btn', {
    on: {
      "click": function($event) {
        _vm.$loading.start()
      }
    }
  }, [_vm._v("Start")]), _vm._v(" "), _c('Btn', {
    on: {
      "click": function($event) {
        _vm.$loading.success()
      }
    }
  }, [_vm._v("Success")]), _vm._v(" "), _c('Btn', {
    on: {
      "click": function($event) {
        _vm.$loading.error()
      }
    }
  }, [_vm._v("Error")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9c7022d0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/demo/Loading.vue
// module id = 685
// module chunks = 0